import * as React from "react";
import type { SVGProps } from "react";
const SvgKtvBarsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="ktv_bars_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M725.333 85.333A42.667 42.667 0 0 1 768 128v469.333h85.333a42.667 42.667 0 1 1 0 85.334H768v128a42.667 42.667 0 1 1-85.333 0V341.333h-85.334a42.667 42.667 0 1 1 0-85.333h85.334V128a42.667 42.667 0 0 1 42.666-42.667zm-426.666 85.334A42.667 42.667 0 0 0 256 213.333v512h-85.333a42.667 42.667 0 1 0 0 85.334H256V896a42.667 42.667 0 1 0 85.333 0V469.333h85.334a42.667 42.667 0 1 0 0-85.333h-85.334V213.333a42.667 42.667 0 0 0-42.666-42.666z"
    />
  </svg>
);
export default SvgKtvBarsIcon;
